import * as Yup from 'yup'
import { GLOBAL_CONSTANTS } from '../../../../utils/GlobalConstants'
export const VTEXTS = {
  addModalHeader: 'Add Vendor',
  editModalHeader: 'Edit Vendor',
  addModalSuccess: 'Vendor created successfully',
  editModalSuccess: 'Vendor updated successfully',
}

export const listConfigs = [
  {
    headerName: 'First Name',
    apiFieldName: 'vendorFirstName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Last Name',
    apiFieldName: 'vendorLastName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Email Id',
    apiFieldName: 'vendorEmailId',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Call Forward Numbers',
    apiFieldName: 'vendorNumbers',
    objectName:"vendorNumber",
    columnWidth: '150',
    type: 'COMMA_SEPERATED_ARRAY_OF_OBJECT',
  },
]

export const defaultVendorProps = {
  vendorFirstName: '',
  vendorLastName: '',
  vendorEmail: '',
  vendorPhoneNumberEnglish: '',
  vendorPhoneNumberSpanish: '',
  id: '',
}
export const validationSchema = {
  vendorFirstName: Yup.string().required('First name is required'),
  vendorEmail: Yup.string().required('Email ID is required').trim().email('Enter a valid email id'),
  vendorPhoneNumberEnglish: Yup.string()
    .required('Call forward number for English is required')
    .matches(/[^a-zA-Z]/, 'Invalid Phone Number')
    .min(10, GLOBAL_CONSTANTS.invalidPhoneNumber)
    .max(10, GLOBAL_CONSTANTS.phoneNumberShouldNotExceedTen)
    .matches(/^[0-9a-zA-Z \b]+$/, GLOBAL_CONSTANTS.invalidPhoneNumber)
    .matches(
      /^(\+|1\s)?(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
      GLOBAL_CONSTANTS.invalidPhoneNumber
    ),
  vendorPhoneNumberSpanish: Yup.string()
    .required('Call forward number for Spanish is required')
    .matches(/[^a-zA-Z]/, GLOBAL_CONSTANTS.invalidPhoneNumber)
    .min(10, GLOBAL_CONSTANTS.invalidPhoneNumber)
    .max(10, GLOBAL_CONSTANTS.phoneNumberShouldNotExceedTen)
    .matches(/^[0-9a-zA-Z \b]+$/,GLOBAL_CONSTANTS.invalidPhoneNumber)
    .matches(
      /^(\+|1\s)?(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
      GLOBAL_CONSTANTS.invalidPhoneNumber
    ),
}